import { __assign } from 'tslib';
import { useContext } from 'react';
import { TextCopyContext, useUpdateFields } from '@invitae/nucleobase-core';
import { useGlobalTextCopy } from './useGlobalTextCopy.esm.js';

var useTextCopy = function (additionalTexts) {
    if (additionalTexts === void 0) { additionalTexts = {}; }
    var _a = useContext(TextCopyContext), componentTexts = _a.componentTexts, componentType = _a.componentType, componentMedias = _a.componentMedias;
    var getByComponentName = useGlobalTextCopy().getByComponentName;
    var fields = __assign(__assign(__assign({}, componentTexts), getByComponentName(componentType)), additionalTexts);
    var updatedFields = useUpdateFields({ fields: fields, keywordsTexts: fields }).updatedFields;
    var getText = function (keyword) {
        return (updatedFields === null || updatedFields === void 0 ? void 0 : updatedFields[keyword]) || "{{".concat(keyword, "}}");
    };
    var getMedia = function (keyword) {
        return componentMedias === null || componentMedias === void 0 ? void 0 : componentMedias[keyword];
    };
    var isKeywordEmpty = function (keyword) {
        return getText(keyword) === "{{".concat(keyword, "}}");
    };
    return {
        getMedia: getMedia,
        getText: getText,
        isKeywordEmpty: isKeywordEmpty,
    };
};

export { useTextCopy };
//# sourceMappingURL=useTextCopy.esm.js.map
